import { CoreIcon } from '../core-icon';
import negativeSVG from '../../assets/icons/negative.svg';
import type { IconProps } from '../core-icon';

export const NegativeIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={negativeSVG} {...props} />;
};
